// YearlyEmployeeInput.js
import React from "react";
import { Grid } from "@mui/material";
import AppTextInput from "../../../../../Component/Common/Components/FormValidationInputs/AppTextInput";
import { MDBox } from "../../../../../Component/Common/Components/MDBox";
import { MDTypography } from "../../../../../Component/Common/Components/MDTypography";
import { Control, FieldValues } from "react-hook-form";
import { ProjectedHeadcountSelectedMethod } from "../../../../../Component/Model/Enum/ProjectedHeadcountMethod";
import { ProjectedHeadcountFieldType } from "../../../../../Component/Model/Enum/ProjectedHeadcountFieldType";

interface YearlyEmployeeInputProps {
  year: number;
  control: Control<FieldValues, any>; 
  employeeField: string;
  growthField: string;
  selectedMethodId: number;
  onFieldChange?: (year: number, fieldType: ProjectedHeadcountFieldType, value: number) => void;
}

const numericOnlyKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
  const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End', '.'];
  const isNumber = /^[0-9]$/.test(e.key);
  const isAllowed = allowedKeys.includes(e.key);

  if (!isNumber && !isAllowed) {
    e.preventDefault();
  }
};

const YearlyEmployeeInput: React.FC<YearlyEmployeeInputProps> = ({
  year,
  control,
  employeeField,
  growthField,
  selectedMethodId,
  onFieldChange
}) => {
  const showLabels = year === 1 || (year === 5 && selectedMethodId !== ProjectedHeadcountSelectedMethod.AnnualGrowthModel);

  return (
    <Grid container spacing={2} alignItems="center" mb={2}>
      <Grid item xs={6}>
        <MDTypography
          variant="button"
          fontWeight="regular"
          style={{ color: "#000000", fontSize: "0.8em" }}
        >
          Expected number of employees or % growth for Year {year}
        </MDTypography>
      </Grid>

      <Grid item xs={6}>
        <MDBox display="flex" alignItems="flex-start" gap={2}>
          <MDBox display="flex" flexDirection="column">
            {showLabels && (
              <MDTypography
                variant="button"
                fontWeight="regular"
                style={{ color: "#000000", fontSize: "0.8em" }}
              >
                Number of Employees
              </MDTypography>
            )}
            <AppTextInput
              control={control}
              name={employeeField}
              label=""
              size="small"
              onChange={(e: any) => {
                const value = parseFloat(e.target.value) || 0;
                onFieldChange?.(year, ProjectedHeadcountFieldType.Employee, value);
              }}
              onKeyDown={numericOnlyKeyDown}
            />
          </MDBox>

          <MDBox display="flex" flexDirection="column">
            {showLabels && selectedMethodId === ProjectedHeadcountSelectedMethod.AnnualGrowthModel && (
              <MDTypography
                variant="button"
                fontWeight="regular"
                style={{ color: "#000000", fontSize: "0.8em" }}
              >
                % Annual Growth
              </MDTypography>
            )}
            {showLabels && selectedMethodId === ProjectedHeadcountSelectedMethod.Year5 && (
              <MDTypography
                variant="button"
                fontWeight="regular"
                style={{ color: "#000000", fontSize: "0.8em" }}
              >
                % Total Growth
              </MDTypography>
            )}
            <AppTextInput
              control={control}
              name={growthField}
              label=""
              size="small"
              onChange={(e: any) => {
                const value = parseFloat(e.target.value) || 0;
                onFieldChange?.(year, ProjectedHeadcountFieldType.Growth, value);
              }}
              onKeyDown={numericOnlyKeyDown}
            />
          </MDBox>
        </MDBox>
      </Grid>
    </Grid>
  );
};
export default YearlyEmployeeInput;
